(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  document.addEventListener('countdownEnded', function() {
    const headerEl = document.querySelector('.header');
    const announcementBarEl = document.querySelector('.announcement-bar');
    if (headerEl && announcementBarEl) {
      headerEl.style.top = 'var(--announcement-bar-height)';
      announcementBarEl.style.height = 'var(--announcement-bar-height)';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["industry-reviews"] && !Shopify.designMode) return;
  try {
    
  const buttons = document.querySelectorAll('.industry-reviews__action-link');
  const allCarousels = document.querySelectorAll('.industry-reviews__inner > div');
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const category = button.getAttribute('data-category');
      const carousel = document.querySelector(`#${category}`);
      allCarousels.forEach((carousel) => {
        carousel.classList.remove('active');
      });
      carousel.classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  // Desktop window media query
  const desktopWindowMQ = window.matchMedia(`(min-width: 768px)`);

  // Clamp utility function
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

  // Timeline elements
  let clickableItems,
    draggableIcon,
    timelineTrack,
    timelineItems,
    timelineWrapper,
    prevButton,
    nextButton,
    mobileIcon,
    mobileTrack,
    itemContainer;

  // Timeline variables
  let distribution, tallestItemHeight;

  // Handle clickable items
  const handleClickableItems = () => {
    clickableItems.forEach((item) => {
      item.addEventListener('click', () => {
        if (!desktopWindowMQ.matches) return;
        clickableItems.forEach((item) => item.classList.remove('active'));
        item.classList.add('active');
      });
    });
  };

  // Handle desktop draggable functionality
  const handleDesktopDraggable = () => {
    if (!draggableIcon || !timelineTrack) return;

    let isDragging = false;
    let startX = 0;
    let mousedownX = 0;
    const clampStart = 0;
    const clampEnd = timelineTrack.offsetWidth - draggableIcon.offsetWidth;

    const handleDrag = (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const walk = startX + e.clientX - mousedownX;
      const clampedWalk = clamp(walk, clampStart, clampEnd);
      draggableIcon.style.setProperty('--icon-left', `${clampedWalk}px`);

      const percentDragged = (clampedWalk / clampEnd) * 100;
      const nearestDistribution = Math.round(percentDragged / distribution) * distribution;
      const nearestIndex = clamp(Math.round(nearestDistribution / distribution), 0, timelineItems.length - 1);

      timelineItems.forEach((item, index) => {
        item.classList.toggle('active', index === nearestIndex);
        if (index === nearestIndex) {
          updateArrowState(nearestIndex);
        }
      });
    };

    draggableIcon.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = draggableIcon.offsetLeft;
      mousedownX = e.clientX;
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
    });

    document.addEventListener('mousemove', handleDrag);
  };

  // Handle arrow navigation
  const updateArrowState = (currentIndex) => {
    prevButton.disabled = currentIndex === 0;
    nextButton.disabled = currentIndex === timelineItems.length - 1;
  };

  const setActiveItem = (index) => {
    timelineItems.forEach((item, i) => {
      item.classList.toggle('active', i === index);
      item.style.height = `${tallestItemHeight}px`;
    });
    draggableIcon.style.setProperty('--icon-left', `${distribution * index}%`);
    updateArrowState(index);
  };

  const handleArrowNavigation = () => {
    if (!prevButton || !nextButton) return;

    prevButton.addEventListener('click', () => {
      const currentIndex = Array.from(timelineItems).findIndex((item) => item.classList.contains('active'));
      if (currentIndex > 0) setActiveItem(currentIndex - 1);
    });

    nextButton.addEventListener('click', () => {
      const currentIndex = Array.from(timelineItems).findIndex((item) => item.classList.contains('active'));
      if (currentIndex < timelineItems.length - 1) setActiveItem(currentIndex + 1);
    });

    // Initialize arrow state
    const initialIndex = Array.from(timelineItems).findIndex((item) => item.classList.contains('active'));
    updateArrowState(initialIndex);
  };

  // Handle mobile functionality
  const handleMobile = () => {
    const setMobileTrackWidth = () => {
      if (!itemContainer || !mobileTrack) return;
      mobileTrack.style.setProperty('--mobile-width', `${itemContainer.scrollWidth}px`);
    };

    const trackMobileScrollX = () => {
      if (!timelineWrapper || !mobileIcon) return;
      timelineWrapper.addEventListener('scroll', () => {
        mobileIcon.style.setProperty('--icon-left', `${timelineWrapper.scrollLeft}px`);
      });
    };

    desktopWindowMQ.addEventListener(
      'change',
      () => {
        if (!itemContainer) return;
        setTimeout(setMobileTrackWidth);
      },
      { passive: true }
    );

    if (!desktopWindowMQ.matches && itemContainer) {
      setMobileTrackWidth();
    }

    trackMobileScrollX();
  };

  const getExactHeight = (item) => {
    if (!item) return;
    const containers = item.querySelectorAll(
      '.timeline__item__image-container, .timeline__item__title-container, .timeline__item__content-container'
    );
    const totalHeight = Array.from(containers).reduce((height, container) => {
      if (container) {
        const styles = window.getComputedStyle(container);
        const marginTop = parseFloat(styles.marginTop);
        const marginBottom = parseFloat(styles.marginBottom);
        return height + container.offsetHeight + marginTop + marginBottom;
      }
      return height;
    }, 0);
    return totalHeight;
  };

  const setTimelineItemsHeight = () => {
    if (!timelineItems || timelineItems.length === 0) return;
    timelineItems.forEach((item) => item.classList.remove('active'));

    requestAnimationFrame(() => {
      const heights = [];

      timelineItems.forEach((item, index) => {
        setTimeout(() => {
          item.classList.add('active');

          setTimeout(() => {
            const height = getExactHeight(item);
            heights[index] = height;

            if (heights.length === timelineItems.length) {
              tallestItemHeight = Math.max(...heights);

              setActiveItem(0);
            }
            item.classList.remove('active');
          }, 100 * index);
        }, 100 * index);
      });
    });
  };

  // Initialize
  const init = () => {
    // Select DOM elements
    clickableItems = document.querySelectorAll('.timeline__item.clickable');
    draggableIcon = document.querySelector('.timeline__desktop-container.draggable .timeline__drag-image-container');
    timelineTrack = document.querySelector('.timeline__desktop-container.draggable .timeline__track');
    timelineItems = document.querySelectorAll('.timeline__desktop-container.draggable .timeline__item');
    timelineWrapper = document.querySelector('.timeline__wrapper');
    prevButton = document.querySelector('.timeline__arrow.timeline__prev');
    nextButton = document.querySelector('.timeline__arrow.timeline__next');
    mobileIcon = document.querySelector('.timeline__mobile-track-container .timeline__drag-image-container');
    mobileTrack = document.querySelector('.timeline__mobile-track-container .timeline__track');
    itemContainer = document.querySelector('.timeline__items-container');

    // Calculate distribution and tallest item height
    distribution = timelineItems.length > 0 ? 100 / timelineItems.length : 0;
    tallestItemHeight = getExactHeight(
      Array.from(timelineItems).find((item) => item.classList.contains('active')) || timelineItems[0]
    );

    // Initialize functionality
    handleClickableItems();
    handleDesktopDraggable();
    handleArrowNavigation();
    handleMobile();
    setTimelineItemsHeight();

    // Update click event listener for timeline items
    timelineItems.forEach((item, index) => {
      item.style.height = `${tallestItemHeight}px`;
      item.addEventListener('click', () => {
        if (!desktopWindowMQ.matches) return;
        setActiveItem(index);
      });
    });

    // Update on window resize
    window.addEventListener('resize', setTimelineItemsHeight);
    // Update on media query change
    desktopWindowMQ.addEventListener('change', setTimelineItemsHeight);
  };

  // Run initialization when DOM is loaded
  document.addEventListener('DOMContentLoaded', init);

  } catch(e) { console.error(e); }
})();
})();
